import { Component, Input } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../providers/tools/tools';
import {
  NavController,
  ViewController,
  ActionSheetController,
} from 'ionic-angular';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { PushNotificationsProvider } from '../../providers/push-notifications/push-notifications';
import { UserProvider } from '../../providers/user/user';

declare let CmKit: any;

@Component({
  selector: 'announcement',
  templateUrl: 'announcement.html',
})
export class AnnouncementComponent {
  log = debug('app:AnnouncementComponent');

  @Input()
  announcement: any = {};
  hideAnnouncement = false;
  takingAction = false;

  constructor(
    public tools: ToolsProvider,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public actionSheet: ActionSheetController,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    public push: PushNotificationsProvider
  ) {}

  ngOnInit(): void {
    this.announcement.description = this.announcement.description.replace(
      /\n/g,
      '<br>'
    );
  }

  openAnnouncement(announcement) {
    if (!_.get(announcement, 'link.url')) return;

    setTimeout(() => {
      if (!this.takingAction) {
        if (_.get(announcement, 'link.type') === 'external') {
          this.tools.openExternalUrl(
            _.get(announcement, 'link.url'),
            'external'
          );
        } else if (_.get(announcement, 'link.type') === 'deep') {
          this.viewCtrl.dismiss('all').then(() => {
            // TODO navTo
            this.tools.openExternalUrl(
              _.get(announcement, 'link.url'),
              'deep-link'
            );
          });
        }
        if (!announcement.adminPreview) {
          this.removeAnnouncement(announcement);
        }
      }
    }, 50);
  }

  removeAnnouncement(announcement) {
    this.crudApi
      .post(
        `/api/users/${this.user.get('_id')}/announcement/${_.get(
          announcement,
          '_id'
        )}`
      )
      .then(res => {
        this.hideAnnouncement = true;
        let viewed = this.user.get('announcements') || [];
        viewed.push(announcement._id);
        this.user.set('announcements', viewed);
        this.log('announcement viewed', res);
      })
      .catch(err => {
        this.log('error viewing announcement', err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/announcement/announcement.ts